import * as Yup from 'yup';

import { endDateNotBeforeStart } from '~clients/forms/care-plans/dateRange';

// Validation for the unified Overview form (Plan Details + Acknowledgements, saved by
// the single Save button). Only editable fields carry rules; package/budget linkage
// persist via their own sections.
export const overviewFormSchema = Yup.object().shape({
  start_date: Yup.string().required('Start date is required'),
  end_date: endDateNotBeforeStart,
});
